import React from 'react';
import axios from 'axios';
import { Table, Loader, Icon } from 'semantic-ui-react';
import { fetchLanguages, fetchDocumentTypes, fetchCertificateReasons, fetchDocumentTemplates, fetchDocumentStatuses } from '../../Lookups/util';
import moment from 'moment';
import PaginationFront from "../../util/PaginationFront";

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class PreviousExternalStudentCertificates extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            certificateReasons: [],
            documentTypes: [],
            documentTemplates: [],
            languages: [],
            documentStatuses: [],
            loading: true,

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

        };
        this.getExternalStudentDocumentRequests = this.getExternalStudentDocumentRequests.bind(this);
        this.fetchLanguagesDocumentTypesAndTemplates = this.fetchLanguagesDocumentTypesAndTemplates.bind(this);
    }

    componentDidMount() {
        let myTab = document.querySelector('#myTab');
        if (myTab && myTab.children[1]) {
            myTab.children[1].classList.remove('segment');
        }

        this.fetchLanguagesDocumentTypesAndTemplates();
    }

    fetchLanguagesDocumentTypesAndTemplates() {
        axios.all([fetchLanguages(), fetchDocumentTypes(), fetchCertificateReasons(), fetchDocumentTemplates(), fetchDocumentStatuses()])
            .then(axios.spread((languagesRes, documentTypeRes, certificateReasonRes, documentTemplatesRes, documentStatusRes) => {
                const languages = languagesRes.data;
                const documentTypes = documentTypeRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const certificateReasons = certificateReasonRes.data.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale)
                        ? el.translations.find(e => e.language === window.$locale).name : el.name : el.name)
                }));
                const documentStatuses = documentStatusRes.data;
                const documentTemplates = documentTemplatesRes.data;
                this.setState({
                    languages,
                    documentTypes,
                    certificateReasons,
                    documentTemplates,
                    documentStatuses
                });
            }))
            .then(res => { this.getExternalStudentDocumentRequests(); })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch languages, document types or templates');
            });
    }


    getExternalStudentDocumentRequests() {
        let obj = { id: this.props.externalStudentId };
        axios.post('/student-documents/requests-for-external-student', { ...obj })
            .then(res => {
                const data = res.data.map(el => ({
                    ...el,
                    id: el.documentRequestId,
                    documentType: this.state.documentTypes.find(e => e.id === el.documentTypeId).name,
                    certificateReason: !!el.certificateReasonId && this.state.certificateReasons.find(e => e.key === el.certificateReasonId).text,
                    status: this.state.documentStatuses.find(e => e.id === el.documentStatusId).name,
                    language: el.languageId ? this.state.languages.find(e => e.id === el.languageId).name : '',
                    date: moment(el.date).format('D. M. YYYY.'),
                    comment: el.comment,
                    processed: this.state.documentStatuses.find(e => e.id === el.documentStatusId).processed
                }
                ));
                this.setState({ data, loading: false });
            })
            .catch(err => {
                this.setState({ error: true, });
                console.log('Failed to fetch results', err);
            });
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    render() {
        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.state.data.slice(indexOfFirstPost, indexOfLastPost);

        return (
            <div>
                {currentPosts.length ?
                    <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                <Table.HeaderCell>Tip dokumenta</Table.HeaderCell>
                                <Table.HeaderCell width="2">Datum</Table.HeaderCell>
                                <Table.HeaderCell width="2">Jezik</Table.HeaderCell>
                                <Table.HeaderCell>Napomena</Table.HeaderCell>
                                <Table.HeaderCell width="3">Status</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>  {currentPosts.map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell verticalAlign="middle">
                                    {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.documentType}<br />{el.certificateReason}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" width="2">
                                    {el.date}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" width="2">
                                    {el.language}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.comment}
                                </Table.Cell>
                                <Table.Cell width="3" verticalAlign="middle" positive={el.status === 'obrađen'} negative={el.status === 'poništen'} warning={el.status === 'primljen zahtjev'}>
                                    {el.status === 'obrađen' ? 'obrađen' : el.status === 'primljen zahtjev' ? 'primljen zahtjev' : 'poništen'}
                                    {el.status === 'obrađen' ? <div style={{ float: 'right' }}><Icon name="checkmark" /> </div> : el.status === 'primljen zahtjev' ? <div style={{ float: 'right' }}><Icon name="arrow down" /> </div>
                                        : <div style={{ float: 'right' }}><Icon name="close" /> </div>}
                                </Table.Cell>
                            </Table.Row>))
                        }
                        </Table.Body>
                    </Table>
                    : this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> : 'Student nema prethodno izdatih dokumenata.'
                }

                {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.state.data.length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}


            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/PreviousExternalStudentCertificates.js